import { useTranslation } from 'react-i18next';
import { Sidepanel } from '@/components/layout/Sidepanel';
import { CompanyAdminContentView } from '../../company-admin/CompanyAdminContentView';
import type { Device } from '../types';

type SidePanelView = 'details' | 'create' | 'company';

interface DeviceSidePanelProps {
  device: Device | null;
  company: { id: string; name: string } | null;
  view: SidePanelView;
  isOpen: boolean;
  onClose: () => void;
}

export function DeviceSidePanel({
  device,
  company,
  view,
  isOpen,
  onClose,
}: DeviceSidePanelProps) {
  const { t } = useTranslation();

  const getTitle = () => {
    switch (view) {
      case 'details':
        return device?.serialNumber || t('devices.sidePanel.details');
      case 'create':
        return t('devices.sidePanel.createTitle');
      case 'company':
        return company?.name || t('devices.sidePanel.company');
      default:
        return '';
    }
  };

  const renderContent = () => {
    switch (view) {
      case 'details':
        return <DeviceDetailsContent device={device} />;
      case 'create':
        return <CreateDeviceContent />;
      case 'company':
        return <CompanyContent companyId={company?.id} />;
      default:
        return null;
    }
  };

  return (
    <Sidepanel
      isOpen={isOpen}
      onClose={onClose}
      title={getTitle()}
    >
      {renderContent()}
    </Sidepanel>
  );
}

function DeviceDetailsContent({ device }: { device: Device | null }) {
  const { t } = useTranslation();

  if (!device) return null;

  return (
    <p className="text-muted-foreground">{t('devices.sidePanel.detailsPlaceholder')}</p>

  );
}

function CreateDeviceContent() {
  const { t } = useTranslation();

  return (
    <p className="text-muted-foreground">{t('devices.sidePanel.createPlaceholder')}</p>
  );
}

function CompanyContent({ companyId }: { companyId?: string }) {
  if (!companyId) return null;

  return (
    <CompanyAdminContentView companyUuid={companyId} showAdminSection={false} />
  );
}
